import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type Variables = {plantCode: string; id: number}

export const useDeleteMaterialStorage = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: void, variables: Variables) => void
} = {}) =>
  useMutation<void, AxiosError, Variables>({
    mutationFn: async ({plantCode, id}) => {
      await ApiClient.axiosInstance.delete<void>(`/plants/${plantCode}/material-storage/${id}`)
    },
    onError,
    onSuccess
  })
